import DashboardOutlinedIcon from '@mui/icons-material/DashboardOutlined'
import { Avatar, Grid, Typography } from '@mui/material'

import { Box } from '@/components/ui'
import { PageCondensed } from '@/layouts'

import { useRouteOrg } from '../../orgRoute'
import { BillingTaxSection } from './components/BillingTaxSection'
import { OrgDetailsSection } from './components/OrgDetailsSection'
import { ResumeSetupCard } from './components/ResumeSetupCard'

export const OverviewTab = () => {
  const org = useRouteOrg()

  return (
    <PageCondensed>
      <Box variant='flexColumn' gap='lg'>
        <Box variant='flex' gap='md'>
          <Avatar variant='titleIcon'>
            <DashboardOutlinedIcon />
          </Avatar>
          <Typography variant='h4' fontWeight={600}>
            Overview
          </Typography>
        </Box>

        <ResumeSetupCard organization={org} />

        {/* Two cards per row on anything wider than a phone; one below that. */}
        <Grid container spacing={2}>
          <Grid size={{ xs: 12, md: 6 }}>
            <OrgDetailsSection org={org} />
          </Grid>
          <Grid size={{ xs: 12, md: 6 }}>
            <BillingTaxSection org={org} />
          </Grid>
        </Grid>
      </Box>
    </PageCondensed>
  )
}
